"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidationError = exports.ValidationErrorResponse = exports.ControllerErrorResponse = exports.BaseError = exports.isControllerError = void 0;
function isControllerError(error) {
    return error.name !== undefined && error.httpCode !== undefined;
}
exports.isControllerError = isControllerError;
var BaseError = /** @class */ (function () {
    function BaseError() {
        this.httpCode = 500;
    }
    return BaseError;
}());
exports.BaseError = BaseError;
var ControllerErrorResponse = /** @class */ (function (_super) {
    __extends(ControllerErrorResponse, _super);
    function ControllerErrorResponse(message, httpCode) {
        if (httpCode === void 0) { httpCode = 500; }
        var _this = _super.call(this) || this;
        _this.httpCode = httpCode;
        _this.name = message;
        return _this;
    }
    return ControllerErrorResponse;
}(BaseError));
exports.ControllerErrorResponse = ControllerErrorResponse;
var ValidationErrorResponse = /** @class */ (function (_super) {
    __extends(ValidationErrorResponse, _super);
    function ValidationErrorResponse(msg) {
        var _this = _super.call(this) || this;
        _this.httpCode = 400;
        _this.name = "ValidationError";
        _this.message = msg.map(function (m) { return JSON.stringify(m, null, 2); });
        return _this;
    }
    return ValidationErrorResponse;
}(BaseError));
exports.ValidationErrorResponse = ValidationErrorResponse;
exports.isValidationError = function (error) {
    var info = error.message;
    return Array.isArray(info);
};
//# sourceMappingURL=CommonErrors.js.map